import { Divider, notification } from "antd";
import { CfdiComplementModel } from "api/generated";
import { COMPLEMENT_PARENT } from "../ComplementsScreen";
import { useState } from "react";
import { CfdiTable } from "./cfdi/CFDITable";
import { CfdiForm } from "./cfdi/CFDIForm";

interface CfdiComplementFormProps {
  parentType: COMPLEMENT_PARENT;
  setNationalNode: (cfdis: CfdiComplementModel[]) => void;
  nacionalData: CfdiComplementModel[];
}

export function CfdiComplementForm({
  parentType,
  setNationalNode,
  nacionalData,
}: CfdiComplementFormProps) {
  const [editingIndex, setEditingIndex] = useState<number>();
  const [cfdiToEdit, setCfdiToEdit] = useState<CfdiComplementModel>();

  // Manejar envío del formulario (agregar o editar)
  const handleFormSubmit = (cfdiData: Partial<CfdiComplementModel>) => {
    let newData: CfdiComplementModel[];

    if (editingIndex !== undefined) {
      // Modo edición: actualizar CFDI existente
      newData = [...nacionalData];
      newData[editingIndex] = { ...newData[editingIndex], ...cfdiData };
    } else {
      // Modo agregar: crear nuevo CFDI
      newData = [...nacionalData, cfdiData];
    }

    setNationalNode(newData);
    setEditingIndex(undefined);
    setCfdiToEdit(undefined);
  };

  // Eliminar CFDI
  const handleRemove = (index: number) => {
    // No permitir eliminar el último CFDI
    if (nacionalData.length <= 1) {
      notification.warning({
        message: "No se puede eliminar",
        description: "Debe haber al menos un CFDI en el complemento nacional.",
      });
      return;
    }

    const newData = nacionalData.filter((_: unknown, i: number) => i !== index);
    setNationalNode(newData);

    // Si estamos editando el elemento que se elimina, cancelar edición
    if (editingIndex === index) {
      setEditingIndex(undefined);
      setCfdiToEdit(undefined);
    }
  };

  return (
    <div>
      <Divider
        orientation="left"
        style={{ fontSize: "15px", borderColor: "#49f5f5ff" }}
      >
        Complemento - Nacional
      </Divider>

      {/* Tabla de los CFDIs que existen en el complemento */}
      <CfdiTable
        data={nacionalData}
        onEdit={(index) => {
          const cfdi = nacionalData?.[index];
          if (!cfdi) return;

          setEditingIndex(index);
          setCfdiToEdit(cfdi);
        }}
        onRemove={handleRemove}
      />

      {/* Formulario para Agregar/Editar CFDI */}
      <CfdiForm
        editingData={cfdiToEdit}
        parentType={parentType}
        onSubmit={handleFormSubmit}
        onCancelEdit={() => {
          setEditingIndex(undefined);
          setCfdiToEdit(undefined);
        }}
        isEditing={editingIndex !== undefined}
      />
    </div>
  );
}
